import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../services/authService";
import storageUtils from "../../Utils/storageUtils";
import { toast } from "react-toastify";
import localStorage from "redux-persist/es/storage";
const { REACT_APP_LOGIN_REDIRECT_URL } = process.env;

// Keep your existing clearAuthData thunk
export const clearAuthData = createAsyncThunk(
  "auth/clearData",
  async (_, { dispatch }) => {
    localStorage.removeItem("persist:auth");
    dispatch({
      type: "persist/PURGE",
      key: "auth",
      result: () => null,
    });
  }
);

// Add new logout thunk

export const logoutThunk = createAsyncThunk(
  "auth/logoutThunk",
  async (redirectUrl, { dispatch }) => {
    try {
      // Clear auth data from Redux
      await dispatch(clearAuthData());

      // Clear application-specific storage
      storageUtils.clearAppStorage();

      // Clear cookies for your application path
      storageUtils.clearCookies();

      // Attempt to logout from backend if needed
      // try {
      //   await authService.logout();
      // } catch (error) {
      //   console.error('Backend logout failed:', error);
      // }

      // Dispatch regular logout action
      dispatch(logout());

      // Handle redirect
      if (redirectUrl) {
        // Ensure redirect is to the correct path
        const baseUrl = window.location.origin;
        const fullRedirectUrl = REACT_APP_LOGIN_REDIRECT_URL;

        window.location.href = fullRedirectUrl;
      }

      // Attempt to close the tab
      window.close();

      return true;
    } catch (error) {
      toast.error("Logout failed");
      console.error("Logout failed:", error);
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
      throw error;
    }
  }
);

// Keep your existing loginThunk
export const loginThunk = createAsyncThunk(
  "auth/login",
  async ({ username, token }, { dispatch, rejectWithValue }) => {
    try {
      await dispatch(clearAuthData()).unwrap();
      const response = await authService.login(username, token);
      localStorage.setItem("knowledge_token", token);
      await authService.updateDomain(
        response.id,
        response.restricted,
        response.partial,
        response.user,
        response.user === "superuser"
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: null,
    loading: false,
    error: null,
    currentRole: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.currentRole = null;
      state.loading = false;
      state.error = null;
    },
    updateCurrentRole: (state, action) => {
      state.currentRole = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Existing login cases
      .addCase(loginThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.user = {
          id: action.payload.id,
          username: action.payload.username,
          email: action.payload.email,
          firstName: action.payload.first_name,
          role: action.payload.role,
          isRestricted: action.payload.restricted,
          isPartial: action.payload.partial,
          userRole: action.payload.user,
        };
        state.token = action.payload.token;
        state.currentRole = action.payload.role;
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add logout thunk cases
      .addCase(logoutThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutThunk.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.currentRole = null;
        state.loading = false;
        state.error = null;
      })
      .addCase(logoutThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, updateCurrentRole } = authSlice.actions;
export default authSlice.reducer;
